import { ComputedStaticTextInput } from '@framework/form/inputs/computed/ComputedStaticTextInput.tsx';
import { ConfigFormItem } from '../../../../../../../ui/form/ConfigFormItem.tsx';
import { type IPaymentRowWidget } from '../../IPaymentRowWidget.ts';

export interface IComputedStringPaymentRowFieldProps {
  name: string;
  label: string;
  help?: string;
  readonly: boolean;
  widget: IPaymentRowWidget;
}

/**
 * Componente di renderizzazione di un campo di tipo stringa calcolato
 * per la voce di costo
 */
export function ComputedStringPaymentRowField(
  props: IComputedStringPaymentRowFieldProps,
) {
  const { name, label, help, readonly, widget } = props;

  return (
    <ConfigFormItem
      name={name}
      label={label}
      help={help}
      readonly={readonly}
      widget={widget}
    >
      <ComputedStaticTextInput name={name} removeBorder />
    </ConfigFormItem>
  );
}
